import script from "./Ikeapage.vue?vue&type=script&setup=true&lang=js"
export * from "./Ikeapage.vue?vue&type=script&setup=true&lang=js"

import "./Ikeapage.vue?vue&type=style&index=0&id=edde195e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edde195e"]])

export default __exports__